var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-timepicker',{staticClass:"time-picker",attrs:{"format":"hh:mm A","value":_vm.value},on:{"input":function($event){return _vm.$emit('change', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }